enum ReceiptReviewStatus {
  Match = "Match",
  MissingReceipt = "Missing Receipt",
  MismatchReceipt = "Mismatch Receipt",
  ExemptReceipt = "Exempt Receipt",
  LostReceipt = "Lost Receipt",
  ApprovedLostReceipt = "Approved Receipt",
}

export default ReceiptReviewStatus;
